import { action, computed, thunk } from "easy-peasy";
import {
  makeAuthorizedDeleteRequestToBackend,
  makeAuthorizedPostRequestToBackend,
  makeUrl,
} from "../helpers/backendApi";
import { message } from "antd";

const starsModel = {
  INITIAL_DATA_ENDPOINT: "stars",
  NAME: "stars",
  initialData: null,
  initialDataReceived: false,
  starCustomer: thunk(
    async (actions, { customerId, customerName }, { getStoreState }) => {
      try {
        const resp = await makeAuthorizedPostRequestToBackend({
          url: makeUrl(`stars/${customerId}`),
          data: {},
          axiosConfig: undefined,
        });
        message.success(`Successfully starred ${customerName}`, 1);
        actions.receiveInitialData(resp.data);
      } catch (e) {
        message.error(`Failed to star ${customerName}`);
      }
    }
  ),
  unstarCustomer: thunk(
    async (actions, { customerId, customerName }, { getStoreState }) => {
      try {
        const resp = await makeAuthorizedDeleteRequestToBackend({
          url: makeUrl(`stars/${customerId}`),
          axiosConfig: undefined,
        });
        message.success(`Successfully unstarred ${customerName}`, 1);
        actions.receiveInitialData(resp.data);
      } catch (e) {
        message.error(`Failed to unstar ${customerName}`);
      }
    }
  ),
  clear: action((state) => {
    state.initialData = null;
    state.initialDataReceived = false;
  }),
  receiveInitialData: action((state, payload) => {
    state.initialData = payload;
  }),
  starsSet: computed(
    ({ initialData }) => initialData && new Set([...initialData])
  ),
};

export { starsModel };
